import { Routes, Route, Navigate } from "react-router-dom";
import { RequireAuth } from "@/components/RequireAuth";
import { AppLayout } from "@/components/AppLayout";
import Login from "@/routes/Login";
import Signup from "@/routes/Signup";
import Overview from "@/routes/Overview";
import Catalogue from "@/routes/Catalogue";
import Orders from "@/routes/Orders";
import TaxVat from "@/routes/TaxVat";
import Markets from "@/routes/Markets";
import Books from "@/routes/Books";
import Integrations from "@/routes/Integrations";
import Settings from "@/routes/Settings";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />

      <Route
        element={
          <RequireAuth>
            <AppLayout />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="/overview" replace />} />
        <Route path="/overview" element={<Overview />} />
        <Route path="/catalogue" element={<Catalogue />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/tax" element={<TaxVat />} />
        <Route path="/markets" element={<Markets />} />
        <Route path="/books" element={<Books />} />
        <Route path="/integrations" element={<Integrations />} />
        <Route path="/settings" element={<Settings />} />
      </Route>

      <Route path="*" element={<Navigate to="/overview" replace />} />
    </Routes>
  );
}
